import React from 'react';
import ReactModal from 'react-modal';
import CloseIcon from '../../content/CloseIcon';

type ClosableModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  children: React.ReactNode | string;
  label?: string;
  style?: React.CSSProperties;
  labelClasses?: string;
  subHeader?: React.ReactNode | null;
  className?: string;
};

const ClosableModal: React.FC<ClosableModalProps> = ({
  isOpen,
  onRequestClose,
  children,
  label,
  style,
  subHeader = null,
  className = '',
  labelClasses = 'm-2 text-black-600 text-2xl',
}: ClosableModalProps) => {
  const modalStyle: ReactModal.Styles = {
    overlay: {
      zIndex: 500,
      backgroundColor: 'rgba(0, 12, 32, .3)',
    },
    content: {
      transform: 'translate(-50%, -50%)',
      minHeight: 150,
      outline: 'none',
      ...style,
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={label}
      className={`checkout-panel-main ${className} p-5 fixed left-1/2 top-1/2 min-w-min overflow-hidden rounded`}
      style={modalStyle}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
    >
      <div>
        <div className="flex flex-row justify-between items-start">
          <span className={`${labelClasses}`}>{label}</span>
          <span
            data-testid="modal-close-button"
            className="pr-4 pt-6 modal-close-button text-lg"
            onClick={onRequestClose}
            onKeyDown={onRequestClose}
            role="button"
            tabIndex={0}
          >
            <CloseIcon />
          </span>
        </div>
        {subHeader}
      </div>
      <div className="modal-body">{children}</div>
    </ReactModal>
  );
};

export default ClosableModal;
